import { Label, Table } from "reactstrap";
import InvoiceFooter from "./InvoiceFooter";
import { InvoiceSixData, InvoiceSixTableData } from "../../../../../data/applications/ECommerce";
import { Total } from "../../../../../constants";

// This component renders an invoice table with dynamic data.
const InvoiceSixTable = () => {
  return (
    <div>
      <div className="table-responsive invoice-table" id="table">
        <Table bordered striped>
          <tbody>
            <tr>
              {/* Mapping through InvoiceSixTableData to populate Table headers */}
              {InvoiceSixTableData.map((data, i) => (
                <td className="item" key={i}><h6 className="p-2 mb-0">{data}</h6></td>
              ))}
            </tr>
            {/* Mapping through InvoiceSixData to populate Table rows */}
            {InvoiceSixData.map((data, i) => (
              <tr key={i}>
                <td>
                  <Label>{data.title}</Label>
                  <p className="m-0">{data.detail}</p>
                </td>
                <td><p>{data.hours}</p></td>
                <td><p>${data.price}</p></td>
                <td><p>${data.total}.00</p></td>
              </tr>
            ))}
            <tr>
              <td></td>
              <td><p className="m-0">HST</p></td>
              <td><p className="m-0">13%</p></td>
              <td><p className="m-0">$419.25</p></td>
            </tr>
            <tr>
              <td /><td />
              <td><h6 className="mb-0 p-2">{Total}</h6></td>
              <td><h6 className="mb-0 p-2">$3,644.25</h6></td>
            </tr>
          </tbody>
        </Table>
      </div>
      <InvoiceFooter />
    </div>
  );
};
export default InvoiceSixTable;